import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE } from '../api-base.token';
import { PermissionResponse } from './permission-response.model';

const path = 'permissions';

@Injectable({
  providedIn: 'root',
})
export class PermissionsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<PermissionResponse[]>(url);
  }
}
